/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/RawDataColumn', 'model/RawDataMappingReport', 'model/RawDataRowReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./RawDataColumn'), require('./RawDataMappingReport'), require('./RawDataRowReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.RawDataSourceReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.RawDataColumn, root.ForStractionServiceApi.RawDataMappingReport, root.ForStractionServiceApi.RawDataRowReportPaginationSlice);
  }
}(this, function(ApiClient, RawDataColumn, RawDataMappingReport, RawDataRowReportPaginationSlice) {
  'use strict';




  /**
   * The RawDataSourceReport model module.
   * @module model/RawDataSourceReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>RawDataSourceReport</code>.
   * @alias module:model/RawDataSourceReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>RawDataSourceReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RawDataSourceReport} obj Optional instance to populate.
   * @return {module:model/RawDataSourceReport} The populated <code>RawDataSourceReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Columns')) {
        obj['Columns'] = ApiClient.convertToType(data['Columns'], [RawDataColumn]);
      }
      if (data.hasOwnProperty('Mappings')) {
        obj['Mappings'] = ApiClient.convertToType(data['Mappings'], [RawDataMappingReport]);
      }
      if (data.hasOwnProperty('Rows')) {
        obj['Rows'] = RawDataRowReportPaginationSlice.constructFromObject(data['Rows']);
      }
      if (data.hasOwnProperty('ErroneousRows')) {
        obj['ErroneousRows'] = ApiClient.convertToType(data['ErroneousRows'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('LastFetchDate')) {
        obj['LastFetchDate'] = ApiClient.convertToType(data['LastFetchDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/RawDataColumn>} Columns
   */
  exports.prototype['Columns'] = undefined;
  /**
   * @member {Array.<module:model/RawDataMappingReport>} Mappings
   */
  exports.prototype['Mappings'] = undefined;
  /**
   * @member {module:model/RawDataRowReportPaginationSlice} Rows
   */
  exports.prototype['Rows'] = undefined;
  /**
   * @member {Integer} ErroneousRows
   * @default 0
   */
  exports.prototype['ErroneousRows'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Date} LastFetchDate
   */
  exports.prototype['LastFetchDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


